/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, scheduled: NonNullable<unknown> }} Native_Release_Widget_Week_CountInputs */

const en_us2_native_release_widget_week_count = /** @type {(inputs: Native_Release_Widget_Week_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.scheduled} workouts`)
};

const pt_br2_native_release_widget_week_count = /** @type {(inputs: Native_Release_Widget_Week_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.scheduled} treinos`)
};

const pt_pt2_native_release_widget_week_count = /** @type {(inputs: Native_Release_Widget_Week_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.scheduled} treinos`)
};

/** @type {(inputs: Native_Release_Widget_Week_CountInputs) => LocalizedString} */
const es_419_native_release_widget_week_count = en_us2_native_release_widget_week_count;

/** @type {(inputs: Native_Release_Widget_Week_CountInputs) => LocalizedString} */
const fr_fr2_native_release_widget_week_count = en_us2_native_release_widget_week_count;

/** @type {(inputs: Native_Release_Widget_Week_CountInputs) => LocalizedString} */
const de_de2_native_release_widget_week_count = en_us2_native_release_widget_week_count;

/** @type {(inputs: Native_Release_Widget_Week_CountInputs) => LocalizedString} */
const it_it2_native_release_widget_week_count = en_us2_native_release_widget_week_count;

/**
* | output |
* | --- |
* | "{done} of {scheduled} workouts" |
*
* @param {Native_Release_Widget_Week_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_week_count = /** @type {((inputs: Native_Release_Widget_Week_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Week_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_week_count(inputs)
	if (locale === "es-419") return es_419_native_release_widget_week_count(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_week_count(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_week_count(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_week_count(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_week_count(inputs)
	return en_us2_native_release_widget_week_count(inputs)
});
export { native_release_widget_week_count as "native-release.widget_week_count" }